<template>
  <div class="public_notes_wrap">
    <div class="public_notes_title">
      <h2>公开笔记总数排行</h2>
      <div class="public_notes_search">
        <el-input 
          v-model="studentName"
          clearable
          placeholder="请输入学生姓名或学号"
          prefix-icon="el-icon-search"
          @change="getSearch"
          maxlength="20"></el-input>
        <el-button class="go_back" @click="getSearch">查询</el-button>
        <el-button class="go_back" @click="goBack">返回</el-button>
      </div>
    </div>
    <div class="public_notes_main" :style="'height:'+(height-150)+'px'" v-loading="loading">
      <el-table
        :data="tableData"
        style="width: 100%;margin-top:16px"
        :header-cell-style="{background:'#EDF4FE'}"
        :height="tableData.length?(height-200):(height-160)"
        class="collegeTable"
        :default-sort = "{prop: 'num', order: 'descending'}"
        @sort-change="sortChange"
      >
        <el-table-column prop="sort" label="名次"></el-table-column>
        <el-table-column prop="name" label="姓名"><template slot-scope="scope"><span>{{ scope.row.name? scope.row.name : '——'}}</span></template></el-table-column>
        <el-table-column prop="jobNumber" label="学号"><template slot-scope="scope"><span>{{ scope.row.jobNumber? scope.row.jobNumber : '——'}}</span></template></el-table-column>
        <el-table-column prop="num" label="公开笔记数" sortable="custom" :sort-orders="['ascending', 'descending']"></el-table-column>
      </el-table>
      <Pagination
        :currentpage="pageTotal.currentPage"
        :limit="pageTotal.pageSize"
        :total="pageTotal.total"
        layout="sizes, prev, pager, next, jumper"
        @handleCurrentChange="handleCurrentChange"
        @handleSizeChange="handleSizeChange"
        :small="true"
        v-if="tableData.length"
      ></Pagination>
    </div>
  </div>
</template>
<script>
import * as api from '@/api/HNstatisticsApi'
import Pagination from "@/components/paginator/paginator";
export default {
  components: {Pagination},
  data() {
    return {
      loading: true,
      courseId: this.$route.query.id,
      classId: this.$route.query.classId,
      height: window.innerHeight,
      tableData: [],
      pageTotal: {
        pageSize: 10,
        total: 0,
        currentPage: 1
      },
      studentName: '', //学生姓名或学号
      sort: 1//0升序1降序
    }
  },
  created() {
    this.getNoteList()
  },
  methods: {
    goBack(){
      this.$router.go(-1)
    },
    getSearch(){
      this.getNoteList()
    },
    getNoteList(){//笔记列表
      let obj = {
        "classId": this.classId,
        "courseId": this.courseId,
        "pageNo": this.pageTotal.currentPage,
        "pageSize": this.pageTotal.pageSize,
        "param": this.studentName,
        "sort": this.sort
      }
      api.getNoteList(obj).then(rs=>{
        if(rs.code==0){
          this.tableData = rs.data.list
          this.pageTotal = {
            pageSize: rs.data.pageSize,
            total: rs.data.total,
            currentPage: rs.data.pageNum
          }
          this.loading = false;
        }else{
          this.$messageError(rs.msg)
        }
      })
    },
    sortChange(row) {
      if(row.order == "ascending"){ this.sort = 0 }else if(row.order == "descending"){ this.sort = 1 }
      this.getNoteList()
    },
    handleCurrentChange(val) {//分页
      this.loading = true;
      this.pageTotal.currentPage = val;
      this.getNoteList()
    },
    handleSizeChange(val){//分页
      this.loading = true;
      this.pageTotal.pageSize = val;
      this.pageTotal.currentPage = 1;
      this.getNoteList()
    },
  },
}
</script>
<style lang="scss">
  .public_notes_wrap{
    margin: 0 16px;
    padding: 0 16px;
    background: #fff;
    box-sizing: border-box;
    position: relative;
    .public_notes_title{
      height: 48px;
      border-bottom: 1px solid #5397F7;
      display: flex;
      align-items: center;
      position: relative;
      margin-top: 16px;
      h2{
        border-left: 2px solid rgba(83,151,247,1);
        color: #5397F7;
        font-size: 14px;
        padding-left: 4px;
        line-height: 10px;
      }
      /deep/ .public_notes_search{
        position: absolute;
        right:0;
        top: 10px;
        display: flex;
        height: 30px;
        .el-input__inner{
          width: 240px;
          height: 30px;
        }
        .el-input__icon{
          line-height: 30px;
        }
        button{
          padding: 5px 18px;
          font-size: 12px;
          color: #5397F7;
          border-color: #5397F7;
          margin-left: 16px;
        }
        button:hover{
          background: #5397F7;
          color: #fff;
        }
      }
    }
    .public_notes_main{
      .collegeTable {
        border: 1px solid #ebebeb;
        border-radius: 4px;
        .el-button.is-round{
          padding: 5px 15px;
          border: 1px solid #5397F7;
          color: #5397F7;
          font-size: 12px;
        }
      }
    }
  }
</style>


// WEBPACK FOOTER //
// src/views/szrt_revision/new_educa_module/educa/classStatistics/comp/publicNoteList.vue